import { useAuth, AppHeader as SharedAppHeader } from '@bri/shared-components';
import { useNavigate } from 'react-router-dom';
import { useWorkspace } from '@/lib/contexts/useWorkspace';
import toast from 'react-hot-toast';

// Get app URLs from environment or use defaults
const USER_DASHBOARD_URL = import.meta.env.VITE_USER_DASHBOARD_URL || 'http://localhost:3000';
const QUAL_ANALYZER_URL = import.meta.env.VITE_QUAL_ANALYZER_URL || 'http://localhost:3001';

export function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { currentWorkspace, workspaces, switchWorkspace } = useWorkspace();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/auth/login');
    } catch (error) {
      toast.error('Failed to log out');
    }
  };

  const handleWorkspaceSwitch = async (workspaceId: string) => {
    try {
      await switchWorkspace(workspaceId);
    } catch (error) {
      console.error('Failed to switch workspace:', error);
      toast.error('Failed to switch workspace');
    }
  };

  const handleNavigateToProfile = () => {
    navigate('/app/profile');
  };

  const handleNavigateToSettings = () => {
    navigate('/app/settings');
  };

  const handleNavigateToWorkspaces = () => {
    navigate('/app/workspaces');
  };

  const handleNavigateHome = () => {
    navigate('/app');
  };

  // Transform workspace format for shared component
  const workspaceList = workspaces.map(ws => ({
    workspaceId: ws.workspaceId,
    name: ws.name || 'Untitled Workspace',
    role: ws.role as 'owner' | 'editor' | 'viewer',
  }));

  const currentWs = currentWorkspace ? {
    workspaceId: currentWorkspace.workspaceId,
    name: currentWorkspace.name || 'Untitled Workspace',
    role: currentWorkspace.role as 'owner' | 'editor' | 'viewer',
  } : undefined;

  return (
    <SharedAppHeader
      appName="Bellomy Insights"
      currentWorkspace={currentWs}
      workspaces={workspaceList}
      onWorkspaceSwitch={handleWorkspaceSwitch}
      userEmail={user?.email}
      userName={user?.name}
      onLogout={handleLogout}
      onNavigateToProfile={handleNavigateToProfile}
      onNavigateToSettings={handleNavigateToSettings}
      onNavigateToWorkspaces={handleNavigateToWorkspaces}
      onNavigateHome={handleNavigateHome}
      appUrls={{
        dashboard: USER_DASHBOARD_URL,
        qualAnalyzer: QUAL_ANALYZER_URL,
      }}
      currentApp="dashboard"
    />
  );
}
